import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SideBarTabs,
  SimulationSideBar,
  PostcodeAllocationSidebar,
} from "./SideBarComponents";
import {
  setSimulatedVolumeOverlayData,
  setDefaultOverlayData,
} from "../../reducers/app";
import { pageToShowIndexSelector } from "../../reducers/app/selector";
import { depotCodeSelector } from "../../reducers/depot/selector";
import "./Sidebar.css";

export const Sidebar = () => {
  const pageToShowIndex = useSelector(pageToShowIndexSelector);
  const depotCode = useSelector(depotCodeSelector);

  const dispatch = useDispatch();

  // Reset list values if the depot changes to make it impossible for wrong previous simulated data to be displayed
  useEffect(() => {
    dispatch(setSimulatedVolumeOverlayData(null));
    dispatch(setDefaultOverlayData([]));
  }, [depotCode, dispatch]);

  return (
    <div className="sidebar">
      {process.env.REACT_APP_DEV_ENV && <SideBarTabs />}
      {pageToShowIndex === 0 && ( // SIMULATION
        <SimulationSideBar />
      )}
      {pageToShowIndex === 1 && <PostcodeAllocationSidebar />}
    </div>
  );
};
